module.exports = __webpack_public_path__ + "img/img_06@2x.4e3f0f66.png";